jQuery(function ($) {

    // hero items
    $('.hero-item .hero-item__link').on('click', function (e) {
        var $parent = $(this).parent();
        $parent.addClass('is-active').siblings().removeClass('is-active');
    });

    $('.hero-item__content').on('click', function (e) {
        e.preventDefault();
        var $parent = $(this).parents('.hero-item');
        if (typeof undefined === $parent || !$parent.length) return false;
        $parent.removeClass('is-active');
    });

    $('.hero-item__close').on('click', function (e) {
        e.preventDefault();
        var $parent = $(this).parents('.hero-item');
        if (typeof undefined === $parent || !$parent.length) return false;
        $parent.removeClass('is-active');
    });

    // testimonials carousel
    $('.testimonial-carousel').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: false,
    });

    // gallery
    // $('a.swipebox').swipebox({
    //     removeBarsOnMobile: false,
    //     hideBarsDelay: 999999,
    //     useSVG: false
    // });

    $('.js-gallery').photoSwipe(
        'img',
        {
            shareEl: false
        }
    );

    // mobile nav
    var $mobNav = $('.mobile-nav');
    $('.menu-burger').on('click', function () {
        $(this).toggleClass('is-active');
        $mobNav.slideToggle();
    });

    // count to
    $('.js-count-to').countTo({});


    $('.js-gallery-slider').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: true,
        navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>']
    });

    $(window).on('load', function () {

        // carousel
        $('.js-carousel').owlCarousel({
            center: true,
            loop: true,
            margin: 10,
            autoWidth: true
        });

    });

});